// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Widgets
 */
.widget {
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  border: 1px solid transparent;
  border-radius: 2px;
  border-color: #e9e9e9;
}
.widget .widget-header .pagination,
.widget .widget-footer .pagination {
  margin: 0;
}
.widget .widget-header {
  color: #767676;
  background-color: #f6f6f6;
  padding: 10px 15px;
  border-bottom: 1px solid #e9e9e9;
  line-height: 30px;
}
.widget .widget-header i {
  margin-right: 5px;
}
.widget .widget-body {
  padding: 20px;
}
.widget .widget-body table thead {
  background: #fafafa;
}
.widget .widget-body table thead * {
  font-size: 14px !important;
}
.widget .widget-body table tbody * {
  font-size: 13px !important;
}
.widget .widget-body .error {
  color: #ff0000;
}
.widget .widget-body button {
  margin-left: 5px;
}
.widget .widget-body div.alert {
  margin-bottom: 10px;
}
.widget .widget-body.large {
  height: 350px;
  overflow-y: auto;
}
.widget .widget-body.medium {
  height: 250px;
  overflow-y: auto;
}
.widget .widget-body.small {
  height: 150px;
  overflow-y: auto;
}
.widget .widget-body.no-padding {
  padding: 0;
}
.widget .widget-body.no-padding .error,
.widget .widget-body.no-padding .message {
  padding: 20px;
}
.widget .widget-footer {
  border-top: 1px solid #e9e9e9;
  padding: 10px;
}
.widget .widget-icon {
  background: #30426a;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  margin-right: 15px;
}
.widget .widget-icon i {
  line-height: 66px;
  color: #ffffff;
  font-size: 30px;
}
.widget .widget-footer {
  border-top: 1px solid #e9e9e9;
  padding: 10px;
}
.widget .widget-title .pagination,
.widget .widget-footer .pagination {
  margin: 0;
}
.widget .widget-content .title {
  font-size: 28px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./layout/resources/less/widgets.less","webpack://./layout/resources/less/mixins.less"],"names":[],"mappings":"AAAA;;EAEE;AAGF;ECJE,iDAAA;EACA,8CAAA;EACA,yCAAA;EDIE,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AANA;;EAQQ,SAAA;AAER;AAVA;EAYQ,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;AACR;AAjBA;EAkBY,iBAAA;AAEZ;AApBA;EAsBQ,aAAA;AACR;AAvBA;EAyBgB,mBAAA;AAChB;AA1BA;EA2BoB,0BAAA;AAEpB;AA7BA;EAgCoB,0BAAA;AAApB;AAhCA;EAqCY,cAAA;AAFZ;AAnCA;EAwCY,gBAAA;AAFZ;AAtCA;EA2CY,mBAAA;AAFZ;AAIQ;EACE,aAAA;EACA,gBAAA;AAFV;AAIQ;EACE,aAAA;EACA,gBAAA;AAFV;AAIQ;EACE,aAAA;EACA,gBAAA;AAFV;AAIQ;EACE,UAAA;AAFV;AACQ;;EAGI,aAAA;AAAZ;AA5DA;EAiEM,6BAAA;EACA,aAAA;AAFN;AAhEA;EAqEQ,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAFR;AAzEA;EA6EY,iBAAA;EACA,cAAA;EACA,eAAA;AADZ;AA9EA;EAmFQ,6BAAA;EACA,aAAA;AAFR;AAlFA;;EAwFY,SAAA;AAFZ;AAtFA;EA6FY,eAAA;EACA,cAAA;AAJZ","sourcesContent":["@import \"mixins.less\";\n\n/**\n * Widgets\n */\n.widget {\n    .box-shadow(0 1px 1px rgba(0, 0, 0, 0.05));\n    background: #ffffff;\n    border: 1px solid transparent;\n    border-radius: 2px;\n    border-color: #e9e9e9;\n    .widget-header, .widget-footer {\n      .pagination {\n        margin: 0;\n      }\n    }\n    .widget-header {\n        color: #767676;\n        background-color: #f6f6f6;\n        padding: 10px 15px;\n        border-bottom: 1px solid #e9e9e9;\n        line-height: 30px;\n        i {\n            margin-right: 5px;\n        }\n    }\n    .widget-body {\n        padding: 20px;\n        table {\n            thead {\n                background: #fafafa;\n                * {\n                    font-size: 14px !important;\n                }\n            }\n            tbody {\n                * {\n                    font-size: 13px !important;\n                }\n            }\n        }\n        .error {\n            color: #ff0000;\n        }\n        button {\n            margin-left: 5px;\n        }\n        div.alert {\n            margin-bottom: 10px;\n        }\n        &.large {\n          height: 350px;\n          overflow-y: auto;\n        }\n        &.medium {\n          height: 250px;\n          overflow-y: auto;\n        }\n        &.small {\n          height: 150px;\n          overflow-y: auto;\n        }\n        &.no-padding {\n          padding: 0;\n          .error, .message {\n            padding: 20px;\n          }\n        }\n    }\n    .widget-footer {\n      border-top: 1px solid #e9e9e9;\n      padding: 10px;\n    }\n    .widget-icon {\n        background: #30426a;\n        width: 65px;\n        height: 65px;\n        border-radius: 50%;\n        text-align: center;\n        vertical-align: middle;\n        margin-right: 15px;\n        i {\n            line-height: 66px;\n            color: #ffffff;\n            font-size: 30px;\n        }\n    }\n    .widget-footer {\n        border-top: 1px solid #e9e9e9;\n        padding: 10px;\n    }\n    .widget-title, .widget-footer {\n        .pagination {\n            margin: 0;\n        }\n    }\n    .widget-content {\n        .title {\n            font-size: 28px;\n            display: block;\n        }\n    }\n}\n",".box-shadow(@shadow) {\n  -webkit-box-shadow: @shadow;\n  -moz-box-shadow: @shadow;\n  box-shadow: @shadow;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
